import {Model} from '@/store/models/model'
import Domain from '@/store/models/domain/domain';
import {Country} from '@/store/models/country'
import User from '@/store/models/user'
import axios from '@/store/vue-axios'


export class DomainHandle extends Model {

  static entity = 'domain_handles'
  static primaryKey = 'handle'
  static apiEntity = 'handles'

  static fields() {
    return {
      id: this.attr(null),
      handle: this.attr(null),
      type: this.attr(null),
      sex: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      organisation: this.attr(null),
      street: this.attr(null),
      number: this.attr(null),
      postcode: this.attr(null),
      city: this.attr(null),
      region: this.attr(null),
      //country_code: this.attr(null),
      country: this.attr(null),
      phone: this.attr(null),
      fax: this.attr(null),
      email: this.attr(null),
      idcard: this.attr(null),
      idcardissuedate: this.attr(null),
      idcardauthority: this.attr(null),
      taxnr: this.attr(null),
      vatnr: this.attr(null),
      dateofbirth: this.attr(null),
      countryofbirth: this.attr(null),
      placeofbirth: this.attr(null),
      regionofbirth: this.attr(null),
      registrationnumber: this.attr(null),
      protection: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      username: this.attr(null),
      user: this.belongsTo(User, 'username'),
      //Relations
      //country: this.belongsTo(Country, 'country_code'),
      local_change: this.boolean(false)
    }
  }
  static async createHandele(handle){
    await axios.post("/domain/handles/create",handle)
  }

  static async editHandle(data){
    //TESTING DEFAULT
    if(data.country === null) data.country = 'DE'
    const x = await axios.post('/domain/handles/edit',{
      ...data
      //params:{...data}
    })
    return x
  }

  static async fetch(handle,update=false) {
    if (!handle) return
    if(DomainHandle.find(handle) && update === false) return DomainHandle.find(handle)
    const response = await axios.get('/domain/handles/show', {
      params: {
        handle: handle
      }
    }).then(response=>{
            DomainHandle.insertOrUpdate({data: response.data.handle})
      })
      .catch(error=>error)

    return  DomainHandle.find(handle)
  }

  static async fetchall(search=""){
    // if(DomainHandle.all().length > 0 ) return
    const result = await axios.get('/domain/handles',{
      params: {
        limit: 10,
        filter: {
          connector: 'OR',
          fields: [
            {
              key: 'handle',
              operator: 'LIKE',
              value: '%' + search + '%'
            },
            {
              key: 'firstname',
              operator: 'LIKE',
              value: '%' + search + '%'
            },
            {
              key: 'lastname',
              operator: 'LIKE',
              value: '%' + search + '%'
            },
            {
              key: 'organisation',
              operator: 'LIKE',
              value: '%' + search + '%'
            }
          ]
        }
      }
    })
    if(result.data.handles) return DomainHandle.insertOrUpdate({data:result.data.handles})

  }

  static vSelectHandleOptions(){
    DomainHandle.fetchall()
    return DomainHandle.all().map(el=>el.handle)
  }
  static birthdates(hid){
    const x = DomainHandle.query().find(hid)
    return {

    dateofbirth:x.dateofbirth,
    placeofbirth:x.placeofbirth,
    regionofbirth:x.regionofbirth,
  }}
  static fullname(hid) {return {firstname:DomainHandle.query().find(hid).firstname, lastname:DomainHandle.query().find(hid).lastname}}
  static fulladdress(hid) {
    const x = DomainHandle.query().find(hid)
    const z = {
      street: x.street,
      number:x.number,
      city: x.city,
      postcode: x.postcode,
      //country: 'A'//Country.returnTitle(x.country) || 'Deutschland'
    }
    return z
  }
  static fullcontact (hid){
    return {email:DomainHandle.query().find(hid).email, phone:DomainHandle.query().find(hid).phone}
  }
  static organisation(hid){return {organisation: DomainHandle.query().find(hid).organisation }}

  static visibleStructure = {
    keys:[
      'id',
      'handle',
      'type'
    ],
    address:[
      'street',
      'number',
      'postcode',
      'city',
      'region',
      'country'
    ],
    contact:[
      'phone',
      'fax',
      'email'
    ],
    dates:[
      'created_at',
      'updated_at'
    ],
    general : [


      'sex',
      'firstname',
      'lastname',
      'organisation',
      'dateofbirth'
    ],
    special : [
      'idcard',
      'idcardissuedate',
      'idcardauthority',
      'taxnr',
      'vatnr',
      'dateofbirth',
      'countryofbirth',
      'placeofbirth',
      'regionofbirth',
      'registrationnumber',
      'protection'
      //'user'
    ],
  }
  static notEditable = {
    PERS : ['firstname','lastname','type','handle','sex','id'],
    ORG : ['organisation','firstname','lastname','type','handle','sex','id'],
    ROLE: ['organisation','firstname','lastname','type','handle','sex','id'],
    NEWHANDLE:['id','handle']
  }

}

export default DomainHandle



// WEBPACK FOOTER //
// ./src/store/models/domain/domain_handle.js